import { render } from "./page-direksi.vue?vue&type=template&id=11e668e2&scoped=true"
import script from "./page-direksi.vue?vue&type=script&lang=js"
export * from "./page-direksi.vue?vue&type=script&lang=js"

import "./page-direksi.vue?vue&type=style&index=0&id=11e668e2&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e668e2"]])

export default __exports__